import { GraduationCap, Stethoscope, Award, Scale, Shield } from 'lucide-react';

const bioSections = [
  { icon: GraduationCap, title: 'Education', content: 'Undergraduate and Medical schooling at the University of Kentucky, earning his M.D. in 1982.' },
  { icon: Stethoscope, title: 'Training', content: 'Dual internship and orthopedic residency at the prestigious Yale–New Haven Hospital. Fellowship in Sports Medicine at the Cincinnati Sports Medicine Midwest Institute for Orthopaedic Surgery (1988).' },
  { icon: Award, title: 'Accolades', content: 'Named to the Cincinnati Magazine Top Doctors List and America\'s Top Surgeons List every year since 2002—over two decades of consecutive recognition.' },
  { icon: Scale, title: 'Leadership', content: 'Past President of the Academy of Medicine of Greater Cincinnati and the Cincinnati Orthopaedic Society. Fellow of the American Academy of Orthopaedic Surgeons.' },
  { icon: Shield, title: 'The "BWC" Edge', content: 'As Past Chairman of the Ohio Governor\'s Advisory Board for Workers\' Compensation, Dr. Larkin gained unparalleled insight into payer logic, compliance structures, and reimbursement policy—the foundational inspiration for LINK\'s compliance engine.' },
];

export function LarkinLegacy() {
  return (
    <section className="py-20 md:py-28 bg-secondary">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-14">
            <p className="text-xs font-semibold tracking-widest uppercase text-primary mb-4">
              The Larkin Legacy
            </p>
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground mb-6">
              Four Decades of Clinical Authority
            </h2>
            <p className="text-muted-foreground text-lg leading-relaxed max-w-2xl mx-auto">
              Dr. John J. Larkin's career spans the full arc of modern orthopedic surgery—from the
              operating room to the boardroom—giving LINK a clinical foundation no software-only
              company can replicate.
            </p>
          </div>

          <div className="space-y-4">
            {bioSections.map((section) => {
              const Icon = section.icon;
              return (
                <div
                  key={section.title}
                  className="rounded-xl border border-border bg-card p-6 hover:shadow-lg transition-shadow"
                >
                  <div className="flex items-start gap-5">
                    <div className="flex-shrink-0 flex items-center justify-center w-11 h-11 rounded-lg bg-primary/10 border border-primary/20">
                      <Icon className="h-5 w-5 text-primary" strokeWidth={1.5} />
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-foreground mb-1.5">
                        {section.title}
                      </h3>
                      <p className="text-muted-foreground leading-relaxed">
                        {section.content}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
